import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from 'src/app/config';
import { PdfZaRekapitulacijuIzdatnicaService } from 'src/app/pdf-ovi/pdfZaRekapitulacijuIzdatnica.service';
import { IzdatniceSirovinaService } from './izdatnice-sirovina.service';

@Component({
  selector: 'app-izdatnice-sirovina',
  templateUrl: './izdatnice-sirovina.component.html',
  styleUrls: ['./izdatnice-sirovina.component.scss'],
})

export class IzdatniceSirovinaComponent implements OnInit {
  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');

  skladistaSirovina: any = [];
  stavkeIzdatnicaSirovina: any = [];
  linije: any = [];
  idOdabranogSkladistaSirovina: any;
  nazivOdabranogSkladistaSirovina: any;
  idOdabraneLinije: any;
  nazivOdabraneLinije: any = '';
  poruka: string;

  moguciOdabir: string[];
  dvSifra: any = 'IZDSIR';
  grupBy: any = 'CIJENA';

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: IzdatniceSirovinaService, private pdfZaRekapitulacijuIzdatnicaService: PdfZaRekapitulacijuIzdatnicaService) {

    this.moguciOdabir = [
      'Po cijeni',
      'Sve',
    ];
    
    this.dohvatiSkladistaSirovina();
    this.dohvatiStavkeIzdatnicaSirovina();
    this.dohvatiSveLinije();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().rekapitulacijaIzdatnica;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  dohvatiSkladistaSirovina() {
    this.skladistaSirovina = [];

    let podaciZaSlanje = {
      idfirma: localStorage.getItem('firma'),
      idkorisnik: localStorage.getItem('idsecuser'),
      ambalaza_i_sirovine_pekar: 1
    };
    //console.log(podaciZaSlanje);

    this.service.dohvatiSkladistaSirovina(podaciZaSlanje).subscribe((res) => {
      //console.log('SKLADISTA SIROVINA: ', res);
      if (res.success === true) {
        this.skladistaSirovina = res.data;
      }
    });
  }
  
  dohvatiSveLinije() {
    this.service.dohvatiSveLinije({}).subscribe((res) => {
      //console.log(res);
      //this.linije = [{ id: '', naziv: 'SVE' }];
      if (res.success == true) {
        for (let linija of res.data) {
          //console.log(linija);
          this.linije.push({
            id: linija.idlinija,
            naziv: linija.li_naziv,
          });
        }
        //console.log(this.linije);
      }
    });
  }

  promjena(e){
    //console.log(e);
    if (e.value == "Sve") {
      this.dvSifra = undefined;
      this.grupBy = undefined;
      this.dohvatiStavkeIzdatnicaSirovina();
    }else{
      this.dvSifra = 'IZDSIR',
      this.grupBy =  'CIJENA',
      this.dohvatiStavkeIzdatnicaSirovina();
    }
  }

  dohvatiStavkeIzdatnicaSirovina() {
    this.poruka = 'Učitavanje...';
    this.stavkeIzdatnicaSirovina = [];

    let podaciZaSlanje = {
      idkorisnik: localStorage.getItem('idsecuser'),
      idfirma: localStorage.getItem('firma'),
      idposlovnica: this.idOdabranogSkladistaSirovina,
      idlinija: this.idOdabraneLinije,
      datumod: this.datumOdFormatiran,
      datumdo: this.datumDoFormatiran,
      dv_sifra: this.dvSifra,
      grupirajpo: this.grupBy,
    };
    //console.log(podaciZaSlanje);

    this.service.dohvatiStavkeIzdatnicaSirovina(podaciZaSlanje).subscribe((res) => {
      //console.log('SKLADISTA SIROVINA: ', res);
      if (res.success === true) {
        this.stavkeIzdatnicaSirovina = res.data;
      }

      if (this.stavkeIzdatnicaSirovina.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
    
    this.dohvatiStavkeIzdatnicaSirovina();
  }

  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');

    this.dohvatiStavkeIzdatnicaSirovina();
  }

  onChangeSkladisteSirovina(e) {
    this.idOdabranogSkladistaSirovina = e.value.idposlovnica;
    this.nazivOdabranogSkladistaSirovina = e.value.po_naziv;

    this.dohvatiStavkeIzdatnicaSirovina();
  }

  onChangeLinija(e){
    if (e.value) {
      this.idOdabraneLinije = e.value.id;
      this.nazivOdabraneLinije = e.value.naziv;
    }else{
      this.idOdabraneLinije = undefined;
      this.nazivOdabraneLinije = '';
    }

    this.dohvatiStavkeIzdatnicaSirovina();
  }

  pdfRekapitulacijaIzdatnica() {
    this.pdfZaRekapitulacijuIzdatnicaService.pdfRekapitulacijaIzdatnica(
      this.stavkeIzdatnicaSirovina,
      this.nazivOdabranogSkladistaSirovina,
      this.nazivOdabraneLinije,
      this.datumDo,
      this.datumOd
    );
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  ngOnInit() {
  }
}
